export class DebtsApi {

    /** @type {ServerData} */ #client;

    constructor(client) {
        this.#client = client;
    }

    /**
     * @param {string} buildingId
     * @param {number} [start]
     * @param {number} [end]
     * @param {Object} [options]
     * @param {boolean} [options.throwError]
     * @param {boolean} [options.excludeCurrentMonth]
     * @return {Promise<unknown>}
     * */
    getBuildingDebts(buildingId, start, end, options = {throwError: false, excludeCurrentMonth: false}) {
        return this.#client.get(`/managers/debts/per_building/${buildingId}`, { end, start, excludeCurrentMonth: options.excludeCurrentMonth }, { throwError: options.throwError });
    }

    /**
     * @param {number} partnerId
     * @param {number} [start]
     * @param {number} [end]
     * @param {Object} [options]
     * @param {boolean} [options.excludeCurrentMonth]
     * @return {Promise<unknown>}
     * */
    getPartnerDebts(partnerId, start, end, options = { excludeCurrentMonth: false }) {
        return this.#client.get(`/managers/debts/per_partner/${partnerId}`, { end, start, excludeCurrentMonth: options.excludeCurrentMonth });
    }
}
